import React from 'react';
import { formatCPF, formatPhone, formatDate } from '../../utils/formatters';
import { CheckCircle, XCircle, Clock, RefreshCw } from 'lucide-react';

const getStatusBadge = (status) => {
  const badges = {
    active:   { color: 'bg-green-100 text-green-800',  Icon: CheckCircle, label: 'Ativo' },
    inactive: { color: 'bg-red-100 text-red-800',      Icon: XCircle,     label: 'Inativo' },
    pending:  { color: 'bg-yellow-100 text-yellow-800', Icon: Clock,       label: 'Pendente' },
  };
  const { color, Icon, label } = badges[status] || badges.pending;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color}`}>
      <Icon className="h-3 w-3 mr-1" />
      {label}
    </span>
  );
};

const MembersTable = ({ members, onUpdateStatus }) => {
  if (!members || members.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        Nenhum associado encontrado.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Telefone</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orixá</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cadastro</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {members.map((member) => (
            <tr key={member.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center space-x-3">
                  {member.photoUrl ? (
                    <img
                      src={member.photoUrl}
                      alt={member.name}
                      className="h-9 w-9 rounded-full object-cover flex-shrink-0"
                    />
                  ) : (
                    <div className="h-9 w-9 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                      <span className="text-sm font-medium text-gray-600">
                        {member.name?.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <div>
                    <div className="text-sm font-medium text-gray-900">{member.name}</div>
                    {member.cpf && (
                      <div className="text-xs text-gray-500">{formatCPF(member.cpf)}</div>
                    )}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{member.email}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {formatPhone(member.phone) || '—'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {member.orixa || '—'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {formatDate(member.createdAt)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {getStatusBadge(member.status)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <div className="flex items-center justify-end gap-2">
                  {member.status === 'pending' && (
                    <>
                      <button
                        onClick={() => onUpdateStatus(member.id, 'active')}
                        className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-green-100 text-green-800 hover:bg-green-200 transition-colors"
                        title="Aprovar associado"
                      >
                        <CheckCircle className="h-3.5 w-3.5" />
                        Aprovar
                      </button>
                      <button
                        onClick={() => onUpdateStatus(member.id, 'inactive')}
                        className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-red-100 text-red-800 hover:bg-red-200 transition-colors"
                        title="Rejeitar associado"
                      >
                        <XCircle className="h-3.5 w-3.5" />
                        Rejeitar
                      </button>
                    </>
                  )}
                  {member.status === 'active' && (
                    <button
                      onClick={() => onUpdateStatus(member.id, 'inactive')}
                      className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-red-100 text-red-800 hover:bg-red-200 transition-colors"
                      title="Inativar associado"
                    >
                      <XCircle className="h-3.5 w-3.5" />
                      Inativar
                    </button>
                  )}
                  {member.status === 'inactive' && (
                    <button
                      onClick={() => onUpdateStatus(member.id, 'active')}
                      className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-green-100 text-green-800 hover:bg-green-200 transition-colors"
                      title="Reativar associado"
                    >
                      <RefreshCw className="h-3.5 w-3.5" />
                      Reativar
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MembersTable;
